/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CompositeRangeAssignmentResponse } from '../models/CompositeRangeAssignmentResponse';
import type { CreateRangeAssignmentsCompositesTupleFilter } from '../models/CreateRangeAssignmentsCompositesTupleFilter';
import type { CreateRangeAssignmentsFilter } from '../models/CreateRangeAssignmentsFilter';
import type { RangeAssignmentOption } from '../models/RangeAssignmentOption';
import type { SalaryRangeTypeOfPay } from '../models/SalaryRangeTypeOfPay';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class RangeAssignmentsService {

    /**
     * Get CompositeRangeAssignment list
     * Returns a flat list of Composites with attached SalaryRanges for each typeOfPay, and a total count
     * @returns any List of CompositeRangeAssignment with total count
     * @throws ApiError
     */
    public static getRangeAssignments({
        planId,
        limit,
        paymarket,
        jobSubFamily,
        jobLevel,
        grade,
        search,
        rangeAssignment,
        typeOfPay,
        offset,
    }: {
        /**
         * Plan ID
         */
        planId: number,
        /**
         * Max number of items to return
         */
        limit?: number,
        paymarket?: Array<number>,
        jobSubFamily?: Array<number>,
        jobLevel?: Array<number>,
        /**
         * Filter by company job grade
         */
        grade?: Array<string>,
        search?: string,
        rangeAssignment?: RangeAssignmentOption,
        typeOfPay?: SalaryRangeTypeOfPay,
        /**
         * Number of items to skip
         */
        offset?: number,
    }): CancelablePromise<{
        data: Array<CompositeRangeAssignmentResponse>;
        /**
         * Total number of composites matching the filter criteria
         */
        totalCount: number;
    }> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/rangeAssignments',
            query: {
                'planId': planId,
                'limit': limit,
                'paymarket': paymarket,
                'jobSubFamily': jobSubFamily,
                'jobLevel': jobLevel,
                'grade': grade,
                'search': search,
                'rangeAssignment': rangeAssignment,
                'typeOfPay': typeOfPay,
                'offset': offset,
            },
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Create range assignments
     * Creates range assignments based on filters and range parameters
     * @returns any Success
     * @throws ApiError
     */
    public static createRangeAssignments({
        requestBody,
    }: {
        requestBody: {
            filters: (CreateRangeAssignmentsFilter | CreateRangeAssignmentsCompositesTupleFilter);
            rangeZoneId: number;
            rangeGroupId: number;
            rangeNameId: number;
        },
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/rangeAssignments',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Export range assignments
     * Schedules an async job to export range assignments data to CSV format
     * @returns any Export job scheduled successfully
     * @throws ApiError
     */
    public static exportRangeAssignments({
        planId,
        limit,
        paymarket,
        jobSubFamily,
        jobLevel,
        grade,
        search,
        rangeAssignment,
        typeOfPay,
        offset,
    }: {
        /**
         * Plan ID
         */
        planId: number,
        /**
         * Max number of items to return
         */
        limit?: number,
        /**
         * Filter by paymarket IDs
         */
        paymarket?: Array<number>,
        /**
         * Filter by job sub-family IDs
         */
        jobSubFamily?: Array<number>,
        /**
         * Filter by job level IDs
         */
        jobLevel?: Array<number>,
        /**
         * Filter by company job grade
         */
        grade?: Array<string>,
        /**
         * Search term for job titles
         */
        search?: string,
        rangeAssignment?: RangeAssignmentOption,
        /**
         * Filter by type of pay
         */
        typeOfPay?: SalaryRangeTypeOfPay,
        /**
         * Number of items to skip
         */
        offset?: number,
    }): CancelablePromise<{
        success: boolean;
        /**
         * ID of the created export file record
         */
        exportFileId: number;
        message: string;
    }> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/rangeAssignments/export',
            query: {
                'planId': planId,
                'limit': limit,
                'paymarket': paymarket,
                'jobSubFamily': jobSubFamily,
                'jobLevel': jobLevel,
                'grade': grade,
                'search': search,
                'rangeAssignment': rangeAssignment,
                'typeOfPay': typeOfPay,
                'offset': offset,
            },
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

}
